const Style = {

  loading: 'opacity-50',
  button: '!w-full sm:!w-[48%] md:!w-[30%] lg:!w-[25%] inline-block mr-0 sm:mr-[2%] last:mr-0',
  buttonContainer: 'flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4',
  normalButton: 'w-[49%] inline-block mr-[2%] last:mr-0'

}

export default Style;